export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11673.efd4aa30.jpg";